import styled from 'styled-components';

export const Wrapper = styled.footer`
  position: absolute;
  bottom: 20px;
  color: var(--color-text-muted);
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;

  a {
    color: var(--color-text-muted);
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
  }
`;
